export const selectFilename = (state: any) => state.file.name